import Router from 'vue-router';
import Vue from 'vue';
import system from './system';
import { Toast } from 'vant';
Vue.use(Router);

const router = new Router({
  base: process.env.NODE_ENV === 'production' ? '/' : '/',
  mode: 'history', // 模式，默认hash
  routes: system
});

const loadingToast = Toast.loading({
  overlay: true,
  message: '加载中...'
});

router.beforeEach((to, from, next) => {
  loadingToast.open();
  // console.log(from.path + ' route to ' + to.path);
  // console.log(!localStorage.getItem('nfm_auth_token'));
  // console.log(to.meta.needToken === true);
  // console.log(!localStorage.getItem('nfm_auth_token') && to.meta.needToken === true);
  //
  // if (!localStorage.getItem('nfm_auth_token') && to.meta.needToken === true) {
  //   next('/ipadIndex');
  // }

  if (to.path === from.path) {
    next(false);
  }
  if (to.meta.title) {
    //判断是否有标题
    console.log(to.meta.title);
    document.title = to.meta.title;
  } else {
    document.title = '国旗教育馆票务预约';
  }
  next();
});

// eslint-disable-next-line no-unused-vars
router.afterEach((to, from) => {
  loadingToast.clear();
});
export default router;
